import React, {Component} from 'react';

export default class Button extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button type="submit"
                    className={"search-component__button " +
                               "search-component__button--" +
                               this.props.type}
                    onFocus={() => this.props.handleFocus("focus")}
                    onBlur={() => this.props.handleFocus("blur")}>
                Search
            </button>
        )
    }
}
